import type { Profile } from '@/types/profile.types'
import { CLEVERLINK_API_BASE_URL, RESOURCES } from '@/constants/apiConstants'
import {
  resourceWithPaginationAndSort,
  resourceWithSecureFetch,
} from '@/utils/apiUtils'

type RouteProfileId = Profile['id'] | string

export const profilesRoutes = {
  root: `${CLEVERLINK_API_BASE_URL}/${RESOURCES.PROFILES}`,
  list: () => profilesRoutes.root,
  detail: (profileId: RouteProfileId) => `${profilesRoutes.root}/${profileId}`,
}

export const fetchProfiles = resourceWithPaginationAndSort<Profile>(
  profilesRoutes.list,
  'profiles',
)

export const fetchProfile = resourceWithSecureFetch<Profile, RouteProfileId>(
  profilesRoutes.detail,
  'profile',
)
